//import i18n from "i18next";
//import React, { Component, Suspense } from 'react';
//import { useTranslation} from 'react-i18next';
let translator = {
    t: function(key){
        let text = window.sizerLangJson.translation[key];
        if(!text) return key;
        return text;
    },

    getLanguageCode: function(){
        return window.sizer_language_code;
    }
}


export default translator;
